// extracted by mini-css-extract-plugin
export default {"wallets":"_30ZqO2A9jfoL88vi+3Ol3g=="};